<layout [menus]="menus" id="home">
    <router-outlet></router-outlet>
</layout>
